import { AxiosInstance } from 'axios';
import { clientUrl } from 'keys';
import { FrameworkDefaultAxiosInstance } from 'framework/xhr/FrameworkDefaultAxiosInstance';

export const DefaultAxiosInstance = (): AxiosInstance => {
	return FrameworkDefaultAxiosInstance(clientUrl);
};
